import { render } from "./ProyectoArchivoTipoForm.vue?vue&type=template&id=34fcb864&scoped=true"
import script from "./ProyectoArchivoTipoForm.vue?vue&type=script&lang=js"
export * from "./ProyectoArchivoTipoForm.vue?vue&type=script&lang=js"

import "./ProyectoArchivoTipoForm.vue?vue&type=style&index=0&id=34fcb864&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34fcb864"]])

export default __exports__